import { Component } from "react";
import { LogoLockup } from "@/components/Logo";
import { AlertTriangle, RotateCcw } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("RollOSS ErrorBoundary caught:", error, info);
  }
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", background: "var(--bg)", display: "grid", placeItems: "center", padding: 24 }} data-testid="error-boundary">
        <div className="card p-10 text-center max-w-[480px]">
          <div className="flex justify-center mb-7"><LogoLockup size={26} beltWidth={210} /></div>
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full mb-5" style={{ background: "rgba(244,185,66,0.15)", border: "1px solid rgba(244,185,66,0.35)" }}>
            <AlertTriangle size={22} style={{ color: "var(--warn)" }} />
          </div>
          <h1 className="text-[22px] font-bold uppercase tracking-tight">Something tapped out</h1>
          <p className="mt-3 text-[14px] leading-relaxed" style={{ color: "var(--text-dim)" }}>
            We hit an unexpected error. The rest of RollOSS is fine — try reloading this page.
          </p>
          {this.state.error?.message && (
            <pre className="mt-5 p-3 rounded-lg text-left text-[11px] mono" style={{ background: "var(--bg-elev)", color: "var(--text-muted)", border: "1px solid var(--border)", overflowX: "auto" }}>
              {String(this.state.error.message)}
            </pre>
          )}
          <button onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }} className="btn btn-primary mt-8" data-testid="error-reload">
            <RotateCcw size={14}/> Reload
          </button>
          <button onClick={() => { window.location.href = "/"; }} className="btn btn-ghost mt-3" data-testid="error-home">
            Back to home
          </button>
        </div>
      </div>
    );
  }
}
